import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementsList extends Layout {
    labelPageTitle: Label;
    sourceHandlingRequirement: DataSource;
    tableHandlingRequirements: Table;
}
